import React, { FC, useEffect, useMemo, useState } from 'react'

import { observer } from 'mobx-react'
import { useLocation, useNavigate } from 'react-router-dom'

import CloseIcon from '@mui/icons-material/Close'
import MenuIcon from '@mui/icons-material/Menu'
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { styled } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'

import { useMediaQuery } from 'utils/hooks'

import { useStore } from 'store'

import HistoryImage from 'sources/images/history.png'
// Get svg
import LibraryImage from 'sources/images/library.png'
import LikedVideosImage from 'sources/images/likedVideos.png'
import MyVideosImage from 'sources/images/myVideos.png'
import ShortsImage from 'sources/images/shorts.png'
import WatchLaterImage from 'sources/images/watchLater.png'

import styles from './styles.module.scss'

interface IProps {}

interface AppBarProps extends MuiAppBarProps {
  open?: boolean
}

const drawerWidth = 200

// NEED Refactor!!!!!!!!!!!!!
const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}))

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}))

export const DrawerMenu: FC<IProps> = observer(() => {
  const minWidth_1531 = useMediaQuery('(min-width: 1531px)')
  const maxWidth_576 = useMediaQuery('(max-width: 576px)')
  const { theme, profile } = useStore()
  const navigate = useNavigate()
  const location = useLocation()
  const [open, setOpen] = useState(false)
  const [tab, setTab] = useState<any>('')

  useEffect(() => {
    if (location.pathname === '/videos/*') {
      setTab('')
    }
  }, [location.pathname])

  const handleDrawerOpen = () => {
    setOpen(true)
  }

  const handleDrawerClose = () => {
    setOpen(false)
  }

  const handleChangeTab = (tab: string) => {
    setTab(tab)

    if (tab === 'library') {
      navigate({ pathname: '/videos/library' })
    } else if (tab === 'shorts') {
      navigate({ pathname: '/videos/shorts' })
    } else if (tab === 'history') {
      navigate({ pathname: '/videos/history' })
    } else if (tab === 'myVideos') {
      // navigate({ pathname: '/videos/my_videos' })
      navigate({ pathname: `/user_videos/${profile.selectedUser.NickName}` })
    } else if (tab === 'watchLater') {
      navigate({ pathname: '/videos/watch_later' })
    } else if (tab === 'likedVideos') {
      navigate({ pathname: '/videos/liked_videos' })
    }

    handleDrawerClose()
  }

  const getWidth = useMemo(() => {
    if (minWidth_1531) {
      return '60px'
    }

    if (maxWidth_576) {
      return '45px'
    }

    return '50px'
  }, [minWidth_1531, maxWidth_576])

  // Change color vor variable
  return (
    <>
      <AppBar
        position="absolute"
        open={open}
        sx={{
          padding: 0,
          width: getWidth,
          height: '100%',
          left: '0',
          backgroundColor: theme.theme === 'dark' ? '#1C1B39' : 'white',
          boxShadow: 'none',
          display: open ? 'none' : 'inherit',
        }}
      >
        <Toolbar
          sx={{
            minHeight: 'unset !important',
            width: getWidth,
            height: '100%',
            padding: '0 !important',
            backgroundColor: theme.theme === 'dark' ? '#1C1B39' : 'white',
            display: open ? 'none' : 'inherit',
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginLeft: 'auto',
              backgroundColor: theme.theme === 'dark' ? '#1C1B39' : 'white',
              color: theme.theme === 'dark' ? 'white' : '#1C1B39',
              ...(open && { display: 'none' }),
            }}
            size="large">
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            backgroundColor: theme.theme === 'dark' ? '#1C1B39' : 'white',
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="temporary"
        anchor="left"
        open={open}
        onClose={(_, reason) =>
          reason === 'backdropClick' && handleDrawerClose()
        }
      >
        <DrawerHeader
          sx={{
            justifyContent: 'left',
          }}
        >
          <IconButton
            onClick={handleDrawerClose}
            sx={{
              color: theme.theme === 'dark' ? 'white' : '#1C1B39',
              marginTop: '10px',
              marginLeft: '14px',
            }}
            size="large">
            <CloseIcon />
          </IconButton>
        </DrawerHeader>
        <List
          sx={{
            '&.MuiList-root': {
              overflow: 'hidden',
            },
            '& .MuiListItemButton-root': {
              color: '#F2F2F2',
              borderTopLeftRadius: '35px',
              borderBottomLeftRadius: '35px',
              overflow: 'hidden',
            },
            '& .MuiListItemButton-root:hover': {
              backgroundColor: '#2428A9',
              color: '#F2F2F2',
              borderTopLeftRadius: '35px',
              borderBottomLeftRadius: '35px',
              overflow: 'hidden',
            },
            '& .MuiListItemIcon-root:hover': {
              width: '100%',
              filter: 'brightness(0) invert(1)',
              overflow: 'hidden',
            },
          }}
        >
          <ListItem
            key={'Library'}
            onClick={() => handleChangeTab('library')}
            disablePadding
            sx={{
              marginLeft: '10px',
              marginBottom: '10px',
              backgroundColor: tab === 'library' ? '#2428A9' : 'null',
              color:
                tab === 'library'
                  ? '#F2F2F2'
                  : theme.theme === 'dark'
                  ? 'white'
                  : '#1C1B39',
              borderTopLeftRadius: tab === 'library' ? '35px' : 'null',
              borderBottomLeftRadius: tab === 'library' ? '35px' : 'null',
              padding: '0px',
            }}
          >
            <ListItemButton
              sx={{
                height: '50px',
                padding: '0',
              }}
            >
              <ListItemIcon
                sx={{
                  marginLeft: '20px',
                  marginRight: '0',
                  marginTop: '-5px',
                  paddingTop: '12px',
                  width: '100%',
                  height: '100%',
                  filter:
                    tab === 'library'
                      ? 'brightness(0) invert(1)'
                      : theme.theme === 'dark'
                      ? 'brightness(0) invert(1)'
                      : 'none',
                }}
              >
                <img src={LibraryImage} height="25px" width="25px" alt="" />
                <ListItemText
                  primary={'Library'}
                  primaryTypographyProps={{
                    color:
                      tab === 'library'
                        ? '#F2F2F2'
                        : theme.theme === 'dark'
                        ? 'white'
                        : '#1C1B39',
                    fontSize: '15px',
                    marginLeft: '10px',
                  }}
                />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
          <ListItem
            key={'Shorts'}
            onClick={() => handleChangeTab('shorts')}
            disablePadding
            sx={{
              marginLeft: '10px',
              marginBottom: '10px',
              backgroundColor: tab === 'shorts' ? '#2428A9' : 'null',
              color:
                tab === 'shorts'
                  ? '#F2F2F2'
                  : theme.theme === 'dark'
                  ? 'white'
                  : '#1C1B39',
              borderTopLeftRadius: tab === 'shorts' ? '35px' : 'null',
              borderBottomLeftRadius: tab === 'shorts' ? '35px' : 'null',
              padding: '0px',
            }}
          >
            <ListItemButton
              sx={{
                height: '50px',
                padding: '0',
              }}
            >
              <ListItemIcon
                sx={{
                  marginLeft: '20px',
                  marginRight: '0',
                  marginTop: '-5px',
                  paddingTop: '12px',
                  width: '100%',
                  height: '100%',
                  filter:
                    tab === 'shorts'
                      ? 'brightness(0) invert(1)'
                      : theme.theme === 'dark'
                      ? 'brightness(0) invert(1)'
                      : 'none',
                }}
              >
                <img src={ShortsImage} height="25px" width="25px" alt="" />
                <ListItemText
                  primary={'Shorts'}
                  primaryTypographyProps={{
                    fontSize: '15px',
                    color:
                      tab === 'shorts'
                        ? '#F2F2F2'
                        : theme.theme === 'dark'
                        ? 'white'
                        : '#1C1B39',
                    marginLeft: '10px',
                  }}
                />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
          <ListItem
            key={'History'}
            onClick={() => handleChangeTab('history')}
            disablePadding
            sx={{
              marginLeft: '10px',
              marginBottom: '10px',
              backgroundColor: tab === 'history' ? '#2428A9' : 'null',
              color:
                tab === 'history'
                  ? '#F2F2F2'
                  : theme.theme === 'dark'
                  ? 'white'
                  : '#1C1B39',
              borderTopLeftRadius: tab === 'history' ? '35px' : 'null',
              borderBottomLeftRadius: tab === 'history' ? '35px' : 'null',
              padding: '0px',
            }}
          >
            <ListItemButton
              sx={{
                height: '50px',
                padding: '0',
              }}
            >
              <ListItemIcon
                sx={{
                  marginLeft: '20px',
                  marginRight: '0',
                  marginTop: '-5px',
                  paddingTop: '12px',
                  width: '100%',
                  height: '100%',
                  filter:
                    tab === 'history'
                      ? 'brightness(0) invert(1)'
                      : theme.theme === 'dark'
                      ? 'brightness(0) invert(1)'
                      : 'none',
                }}
              >
                <img src={HistoryImage} height="25px" width="25px" alt="" />
                <ListItemText
                  primary={'History'}
                  primaryTypographyProps={{
                    fontSize: '15px',
                    color:
                      tab === 'history'
                        ? '#F2F2F2'
                        : theme.theme === 'dark'
                        ? 'white'
                        : '#1C1B39',
                    marginLeft: '10px',
                  }}
                />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
          <ListItem
            key={'My videos'}
            onClick={() => handleChangeTab('myVideos')}
            disablePadding
            sx={{
              marginLeft: '10px',
              marginBottom: '10px',
              backgroundColor: tab === 'myVideos' ? '#2428A9' : 'null',
              color:
                tab === 'myVideos'
                  ? '#F2F2F2'
                  : theme.theme === 'dark'
                  ? 'white'
                  : '#1C1B39',
              borderTopLeftRadius: tab === 'myVideos' ? '35px' : 'null',
              borderBottomLeftRadius: tab === 'myVideos' ? '35px' : 'null',
              padding: '0px',
            }}
          >
            <ListItemButton
              sx={{
                height: '50px',
                padding: '0',
              }}
            >
              <ListItemIcon
                sx={{
                  marginLeft: '20px',
                  marginRight: '0',
                  marginTop: '-5px',
                  paddingTop: '12px',
                  width: '100%',
                  height: '100%',
                  filter:
                    tab === 'myVideos'
                      ? 'brightness(0) invert(1)'
                      : theme.theme === 'dark'
                      ? 'brightness(0) invert(1)'
                      : 'none',
                }}
              >
                <img src={MyVideosImage} height="25px" width="25px" alt="" />
                <ListItemText
                  primary={'My videos'}
                  primaryTypographyProps={{
                    fontSize: '15px',
                    color:
                      tab === 'myVideos'
                        ? '#F2F2F2'
                        : theme.theme === 'dark'
                        ? 'white'
                        : '#1C1B39',
                    marginLeft: '10px',
                  }}
                />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
          <ListItem
            key={'Watch later'}
            onClick={() => handleChangeTab('watchLater')}
            disablePadding
            sx={{
              marginLeft: '10px',
              marginBottom: '10px',
              backgroundColor: tab === 'watchLater' ? '#2428A9' : 'null',
              color:
                tab === 'watchLater'
                  ? '#F2F2F2'
                  : theme.theme === 'dark'
                  ? 'white'
                  : '#1C1B39',
              borderTopLeftRadius: tab === 'watchLater' ? '35px' : 'null',
              borderBottomLeftRadius: tab === 'watchLater' ? '35px' : 'null',
              padding: '0px',
            }}
          >
            <ListItemButton
              sx={{
                height: '50px',
                padding: '0',
              }}
            >
              <ListItemIcon
                sx={{
                  marginLeft: '20px',
                  marginRight: '0',
                  marginTop: '-5px',
                  paddingTop: '12px',
                  width: '100%',
                  height: '100%',
                  filter:
                    tab === 'watchLater'
                      ? 'brightness(0) invert(1)'
                      : theme.theme === 'dark'
                      ? 'brightness(0) invert(1)'
                      : 'none',
                }}
              >
                <img src={WatchLaterImage} height="25px" width="25px" alt="" />
                <ListItemText
                  primary={'Watch later'}
                  primaryTypographyProps={{
                    fontSize: '15px',
                    color:
                      tab === 'watchLater'
                        ? '#F2F2F2'
                        : theme.theme === 'dark'
                        ? 'white'
                        : '#1C1B39',
                    marginLeft: '10px',
                  }}
                />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
          <ListItem
            key={'Liked videos'}
            onClick={() => handleChangeTab('likedVideos')}
            disablePadding
            sx={{
              marginLeft: '10px',
              marginBottom: '10px',
              backgroundColor: tab === 'likedVideos' ? '#2428A9' : 'null',
              color:
                tab === 'likedVideos'
                  ? '#F2F2F2'
                  : theme.theme === 'dark'
                  ? 'white'
                  : '#1C1B39',
              borderTopLeftRadius: tab === 'likedVideos' ? '35px' : 'null',
              borderBottomLeftRadius: tab === 'likedVideos' ? '35px' : 'null',
              padding: '0px',
            }}
          >
            <ListItemButton
              sx={{
                height: '50px',
                padding: '0',
              }}
            >
              <ListItemIcon
                sx={{
                  marginLeft: '20px',
                  marginRight: '0',
                  marginTop: '-5px',
                  paddingTop: '12px',
                  width: '100%',
                  height: '100%',
                  filter:
                    tab === 'likedVideos'
                      ? 'brightness(0) invert(1)'
                      : theme.theme === 'dark'
                      ? 'brightness(0) invert(1)'
                      : 'none',
                }}
              >
                <img src={LikedVideosImage} height="25px" width="25px" alt="" />
                <ListItemText
                  primary={'Liked videos'}
                  primaryTypographyProps={{
                    fontSize: '15px',
                    color:
                      tab === 'likedVideos'
                        ? '#F2F2F2'
                        : theme.theme === 'dark'
                        ? 'white'
                        : '#1C1B39',
                    marginLeft: '10px',
                  }}
                />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>
    </>
  );
})

DrawerMenu.displayName = 'DrawerMenu'
